<template>
  <div class="invadobay-preview__card">
    <vb-card
      :card="{
        image: default_image,
        image_style: {
          cursor: 'pointer',
          'background-color': 'white',
          ...(!elem.cover_media
            ? {
              'background-size': '45%',
            }
            : {}),
        },
        title: elem.title,
        title_style: { cursor: 'pointer' },
        title_popover: elem.title, 
        text: `<div class='text-muted' style='height:3lh'>${
          elem.description || ''
        }</div>`,
        text_popover: elem.description, 
        text_clamped: true,
        variant: 'vertical',
      }"
      @click_image="(e) => $refs[invadobay_path].navigate(e || {})"
      @click_title="(e) => $refs[invadobay_path].navigate(e || {})"
    >
      <template #footer>
        <custom-link
          :ref="invadobay_path"
          :route_path="invadobay_path"
          :as_default="get_config('guiSettings.openDetailNewTab', false)"
        >
          <template #content>
            <span class="text-info link"> Vedi tutte le proposte </span>
          </template>
        </custom-link>
      </template>
    </vb-card>
  </div>
</template>

<script>
  import { get_config } from '@/utilities/commons';

  export default {
    name: 'invadobay-card-preview',
    props: {
      elem: { type: Object, required: true },
    },
    data() {
      return {
        invadobay_path: `/invadobay/${this.elem.slug}`,
      };
    },
    computed: {
      default_image() {
        if ((this.elem.cover_media || {}).url) {
          return this.elem.cover_media.url;
        }
        if (this.is_vivamod()) {
          return `/assets/email/logo-vivamod-mt.png`;
        }
        if (this.is_hotels()) {
          return `/assets/email/logo-vivamod-hotels.png`;
        }
        return `/assets/email/logo-vadobay-live.png`;
      },
    },
    methods: {
      get_config,
    },
  };
</script>

<style lang="scss" scoped>
  .invadobay-preview__card {
    margin: 0 $grid-gutter-width / 2;
  }
</style>
